import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useReducer } from 'react';
import { ActionOperationStatus } from '@atlaskit/linking-types';
import { useDatasourceTableFlag } from './useDatasourceTableFlag';
var loadOptions = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var fetchInputs,
      executeFetch,
      result,
      operationStatus,
      entities,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          fetchInputs = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          executeFetch = _args.length > 1 ? _args[1] : undefined;
          if (executeFetch) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", []);
        case 4:
          _context.next = 6;
          return executeFetch(fetchInputs);
        case 6:
          result = _context.sent;
          operationStatus = result.operationStatus, entities = result.entities;
          if (!(operationStatus === ActionOperationStatus.FAILURE)) {
            _context.next = 10;
            break;
          }
          throw new Error('Failed to fetch status options');
        case 10:
          return _context.abrupt("return", entities !== null && entities !== void 0 ? entities : []);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function loadOptions() {
    return _ref.apply(this, arguments);
  };
}();
var reducer = function reducer(state, payload) {
  return _objectSpread(_objectSpread({}, state), payload);
};
export var useLoadOptions = function useLoadOptions(_ref2) {
  var fetchInputs = _ref2.fetchInputs,
    executeFetch = _ref2.executeFetch,
    emptyOption = _ref2.emptyOption;
  var _useReducer = useReducer(reducer, {
      isLoading: true,
      options: [],
      hasFailed: false
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    _useReducer2$ = _useReducer2[0],
    options = _useReducer2$.options,
    isLoading = _useReducer2$.isLoading,
    hasFailed = _useReducer2$.hasFailed,
    dispatch = _useReducer2[1];
  var _useDatasourceTableFl = useDatasourceTableFlag({
      isFetchAction: true
    }),
    showErrorFlag = _useDatasourceTableFl.showErrorFlag;
  useEffect(function () {
    var isMounted = true;
    // Set the loading state before sending the request
    dispatch({
      isLoading: true
    });
    // Query the options
    loadOptions(fetchInputs, executeFetch).then(function (options) {
      if (isMounted) {
        dispatch({
          isLoading: false,
          options: emptyOption ? [emptyOption].concat(_toConsumableArray(options)) : options,
          hasFailed: false
        });
      }
    }).catch(function (err) {
      showErrorFlag();
      dispatch({
        isLoading: false,
        options: [],
        hasFailed: true
      });
    });
    return function () {
      isMounted = false;
    };
  }, [fetchInputs, executeFetch, showErrorFlag, emptyOption]);
  return {
    options: options,
    isLoading: isLoading,
    hasFailed: hasFailed
  };
};